<template>
	<div class="item">
		<div class="item-quantity" :class="{ 'flex-start': !editable }">
			<template v-if="editable">
				<button @click="changeQuantity(1)">
					<i class="sk-icon-chevron-up-regular"></i>
				</button>
			</template>
			<span>{{ item.quantity }}</span>
			<template v-if="editable && !decrementDisabled">
				<button @click="changeQuantity(-1)">
					<i class="sk-icon-chevron-down-regular"></i>
				</button>
			</template>
		</div>
		<div class="item-text">
			<div class="item-title">{{ item.name }}</div>
			<div
				v-if="Object.keys(options).length !== 0"
				class="item-subtext options"
			>
				{{ options }}
			</div>
			<div class="item-subtext">
				<i class="sk-icon-utensils-solid"></i>
				{{ item.brand }}
			</div>
		</div>
		<div class="item-price">
			{{ totalPrice | currency }}
		</div>
		<template v-if="editable">
			<button @click="deleteClicked()" class="remove-item">
				<i class="sk-icon-times-regular"></i>
			</button>
		</template>
	</div>
</template>

<style scoped>
.item {
	display: flex;
	align-items: center;
	padding: 28px 14px 24px 22px;
	border: 1px solid var(--sk-greyborder);
	background: var(--gR-white);
	color: var(--gR-base-90);
	font-weight: var(--sk-font-bold);
	font-size: 14px;
	border-top: 0px;
}

.item-subtext {
	font-size: 10px;
	color: var(--sk-grey3);
	padding-top: 10px;
}

.item-subtext > i {
	padding-right: 10px;
	color: var(--sk-grey3);
}

.options {
	font-weight: var(--sk-font-regular);
}

.item-quantity {
	margin-right: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
}

.flex-start {
	align-items: flex-start;
	margin-bottom: auto;
}

.flex-start.item-quantity span {
	padding: 0px;
}

.item-quantity span {
	padding: 10px 0;
}

.item-price {
	margin-left: auto;
	margin-right: 11px;
	margin-bottom: auto;
}

.item > i {
	color: var(--sk-grey2);
	font-size: 15px;
}

button {
	background: var(--gR-white);
	display: flex;
	align-items: center;
}

.remove-item {
	margin-left: 26px;
}
</style>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"

export default {
	name: "ReceiptItem",
	data: function () {
		return {
			showingEditOptions: false
		}
	},
	props: {
		item: Object,
		editable: {
			type: Boolean,
			default: true
		},
		showRestaurantName: {
			type: Boolean,
			default: true
		},
		showPrice: {
			type: Boolean,
			default: true
		}
	},
	mixins: [currencyFilterMixin],
	computed: {
		totalPrice() {
			return (
				Object.values(this.item.meta)
					.flat()
					.reduce(
						(previous, current) => previous + current.price,
						parseFloat(this.item.subtotal / this.item.quantity)
					) * this.item.quantity
			)
		},
		options() {
			let options = []
			Object.values(this.item.meta).map((option) => {
				options.push(option.value)
			})
			return options.join(", ")
		},
		decrementDisabled() {
			return this.item.quantity <= 1
		}
	},
	methods: {
		changeQuantity(value) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg:
					value > 0
						? "Cart Item Quantity Increase"
						: "Cart Item Quantity Decrease",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("updateItemCount", {
				quantity: this.item.quantity + value,
				item: this.item
			})
		},
		editClicked() {
			if (!this.editable) {
				return
			}
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Cart Item Edit Clicked",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("editItem", this.item)
			this.$router.push({
				query: {
					item_id: this.item.id,
					menu_id: this.item.menu_id,
					editing: "true"
				}
			})
		},
		deleteClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Cart Item Remove Clicked",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("removeItemFromCart", this.item)
		}
	}
}
</script>